import React, { useState, useRef, useEffect } from "react";
import {
  Collapse,
  Input,
  Button,
  Flex,
  Form,
  Switch,
  Typography,
  Select
} from "antd";
import {
  MinusCircleOutlined,
  PlusOutlined,
  DeleteOutlined,
  QuestionCircleOutlined,
  LockOutlined,
} from "@ant-design/icons";

import globalData from "../../config/global_data";
const { Text } = Typography;

const CommonAttributeList = ({ setRemovedValues, setSavedattributes, customfielddata = null, setHasAttributeError = () => {} }) => {
  const [attributes, setAttributes] = useState([]);
  const [removedattributes, setRemovedattributes] = useState([]);
  const [options, setOptions] = useState([])
  const dragItem = useRef();
  const dragOverItem = useRef();


  useEffect(() => {
    const fetchData = async () => {
      let customdata = []
      if (customfielddata.prdouct_data && customfielddata.prdouct_data.custom_fields && customfielddata.prdouct_data.custom_fields.length > 0) {
        customdata = customfielddata.prdouct_data.custom_fields
      }
      if (customfielddata.custom_fields && customfielddata.custom_fields.length > 0) {
        customdata = customfielddata.custom_fields
      }
      if (customdata && globalData && globalData.attribute_tree.length > 0) {
        const mappedData = await globalData.attribute_tree.map((item, index) => {
          let value = [{}]
          const pattern = new RegExp(item.attri_pattern);
          const return_data = customdata.filter(initem => pattern.test(initem.name ? initem.name : initem.key))

          let values_mapped = null, selected_values = []
          if (item.attribute_element_type == "dropdown" && item.values_data && item.values_data.length > 0) {


            values_mapped = item.values_data.map((item2) => ({
              value: item2.values,
              label: item2.values
            }))

            for (let k = 0; k < return_data.length; k++) {
              const finallist = return_data[k].value.split(",");

              selected_values = finallist
            }
          }
          for (let k = 0; k < return_data.length; k++) {
            const element = return_data[k];
            let indexvalue = element.name ? element.name.replace(/\D/g, '') : element.key.replace(/\D/g, '')
            indexvalue = indexvalue === "" ? 1 : indexvalue
            value[indexvalue - 1] = {
              val: element.values ? element.values : element.value,
              key: element.id
            }
          }

          return ({
            name: item.name,
            values: value,
            max_size: item.max_size,
            min_size: item.min_size,
            is_required: item.is_required,
            attribute_element_type: item.attribute_element_type,
            attribute_key: item.attribute_key,
            id: item.id,
            store_id: item.store_id,
            info_text: item.info_text,
            pattern: item.attri_pattern,
            values_mapped,
            selected_values
          })
        })
        setAttributes(mappedData); // set api data   

      }
    };

    fetchData();
  }, [customfielddata]);

  useEffect(() => {
    setRemovedValues({ custom_fields: removedattributes });
    setSavedattributes({ custom_fields: attributes });
    // Check for errors in attributes and notify parent
    const hasError = attributes.some(attr =>
      (attr.values || []).some(val => val && val.error)
    );
    setHasAttributeError(hasError);
  }, [attributes, setSavedattributes]);

  const handleSort = () => {
    const currentItem = attributes[dragItem.current];
    const updatedItems = [...attributes];
    updatedItems.splice(dragItem.current, 1);
    updatedItems.splice(dragOverItem.current, 0, currentItem);

    setAttributes(updatedItems);
    dragItem.current = null;
    dragOverItem.current = null;
  };

  const addAttribute = () => {
    setAttributes([
      ...attributes,
      {
        name: `New Attribute ${attributes.length + 1}`,
        values: [{ key: "", val: "" }],
        isEditable: true,
      },
    ]);
  };

  const updateAttributeName = (index, newName) => {
    const updated = [...attributes];
    updated[index].name = newName;
    setAttributes(updated);
  };

  const updateValue = (attrIndex, valIndex, newValue, key = "") => {
    const updated = [...attributes];

    const hasError = key && newValue.trim() === "";
    updated[attrIndex].values[valIndex] = {
      val: newValue,
      key,
      error: hasError ? "This field is required." : "",
    };

    setAttributes(updated);
  };

  const addValue = (attrIndex) => {
    const updated = [...attributes];
    let missing_indexes = []
    for (let index = 0; index < attributes[attrIndex].values.length; index++) {
      const element = attributes[attrIndex].values[index];
      if (!element) {
        missing_indexes.push(index)
      }
    }
    if (missing_indexes.length > 0) {
      updated[attrIndex].values[missing_indexes[0]] = { key: "", val: "" };
    } else {
      if (attributes[attrIndex].max_size)
        updated[attrIndex].values.push({ key: "", val: "" });
    }
    setAttributes(updated);
  };

  // const removeValue = (attrIndex, valIndex) => {
  //   const updated = [...attributes];
  //   const removed = updated[attrIndex].values.splice(valIndex, 1);

  //   // Store removed value
  //   setRemovedValues(prev => [...prev, ...removed]);

  //   setAttributes(updated);
  // };

  // const removeAttribute = (index) => {
  //   const updated = attributes.filter((_, i) => i !== index);
  //   setAttributes(updated);
  // };
  const handleValuesChange = (e, attrIndex) => {
    attributes[attrIndex].selected_values = e;
    attributes[attrIndex].values[0].val = e.join(",");
    const updated = [...attributes];
    setAttributes(updated);
  };

  const innerCollapseItems = attributes.map((attribute, index) => {
    const isDraggable = attribute.name !== "Primary Description";


    const removeValue = async (attrIndex, valIndex, newValue, key = "") => {
      const updated = [...attributes];
      let removed = await updated[attrIndex].values.find((val, index) => index === valIndex);

      // Store removed value
      if (removed) {
        await setRemovedattributes([
          ...removedattributes,
          removed.key
        ]);
      }
      updated[attrIndex].values = updated[attrIndex].values.filter((_, index) => index !== valIndex);
      setAttributes(updated);
    };

    return {
      key: attribute.name,
      label: attribute.name,
      children: (
        <div
          className="panelname"
          {...(isDraggable && {
            draggable: true,
            onDragStart: () => (dragItem.current = index),
            onDragEnter: () => (dragOverItem.current = index),
            onDragEnd: handleSort,
            onDragOver: (e) => e.preventDefault(),
          })}
        >
          <Form.Item
            className="attributeFormItemName"
            label={
              <span>
                Attribute Name&nbsp;
                {/* <QuestionCircleOutlined
                  style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                  title={attribute.info_text}
                /> */}
              </span>
            }
            style={{ marginBottom: 8 }}
            name={attribute.name}
          >
            <Input
              value={attribute.name}
              onChange={(e) => updateAttributeName(index, e.target.value)}
              placeholder={attribute.name}
              suffix={!attribute.isEditable && <LockOutlined />}
              disabled={!attribute.isEditable}
            />
          </Form.Item>

          {attribute.attribute_element_type !== "dropdown" && attribute.values.map((value, valIndex) => (
            <Form.Item
              className="attributeFormItem"
              key={valIndex}
              label={
                <span>
                  Value {valIndex + 1}&nbsp;
                  {/* <QuestionCircleOutlined
                    style={{ color: "rgba(0, 0, 0, 0.45)", cursor: "pointer" }}
                    title={attribute.info_text}
                  /> */}
                </span>
              }
              style={{ marginBottom: 8 }}
              validateStatus={value.error ? "error" : ""}
              help={value.error}
            >
              <Flex
                style={{
                  display: "flex",
                  paddingBottom: "20px",
                  width: "100%",
                }}
                align="start"
                size={8}
              >
                <div style={{ width: "100%" }}>
                  <Input.TextArea
                    value={value.val}
                    onChange={(e) =>
                      updateValue(index, valIndex, e.target.value, value.key)
                    }
                    maxLength={250}
                    style={{ width: "100%" }}
                    showCount={{
                      formatter: ({ count, maxLength }) =>
                        `${count}/${maxLength} characters`,
                    }}
                  />
                </div>
                {attribute.values.length > 1 && (
                  <Button
                    type="text"
                    danger
                    icon={<MinusCircleOutlined />}
                    onClick={() => removeValue(index, valIndex, value, value.key)}
                    style={{ width: 32, padding: 0 }}
                  />
                )}
              </Flex>
            </Form.Item>
          ))}

          {attribute.attribute_element_type === "dropdown" &&
            <Form.Item
              label={
                <span>
                  Values&nbsp;
                  {/* <QuestionCircleOutlined
                    style={{
                      color: "rgba(0, 0, 0, 0.45)",
                      cursor: "pointer",
                    }}
                    title="This is the SAP SKU."
                  /> */}
                </span>
              }
              className="attribute_values dropdown_values"
              style={{width:"100%"}}
            >
              <Select
                mode="multiple"
                optionFilterProp="label"
                allowClear
                showSearch
                style={{ width: "100%" }}
                placeholder="Select Values"
                defaultValue={attribute.selected_values}
                onChange={e => handleValuesChange(e, index)}
                options={attribute.values_mapped}
              />
            </Form.Item>
          }
          {attribute.attribute_element_type !== "dropdown" && <div className="btnBox">
            <Button
              disabled={attribute.max_size <= attribute.values.length}
              onClick={() => addValue(index)}
              icon={<PlusOutlined />}
            >
              Add a value
            </Button>
          </div>}

          <div className="SwitchBox" >
            <Switch defaultChecked disabled />
            <Text className="SwitchText">Visible on PDP</Text>
          </div>

          {/* {attribute.isEditable && (
            <div className="btnBox btnRight">
              <Button
                type="primary"
                danger
                onClick={() => removeAttribute(index)}
                style={{ marginTop: 8, marginLeft: "auto" }}
                icon={<DeleteOutlined />}
              >
                Remove Attribute
              </Button>
            </div>
          )} */}
        </div>
      ),
    };
  });

  return (
    <Collapse
      defaultActiveKey={["product-page-details"]}
      items={[
        {
          key: "product-page-details",
          label: "Product page details",
          children: (
            <>
              <Collapse defaultActiveKey={["0"]} items={innerCollapseItems} />
            </>
          ),
        },
      ]}
    />
  );
};

export default CommonAttributeList;
